module.exports = __webpack_public_path__ + "img/shirt-long-sleeve.9d06770c.svg";